import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./Pill.module.css";

interface PillSkeletonProps {
  showIcon?: boolean;
  showLabel?: boolean;
  showTooltip?: boolean;
  variant?: "default" | "info" | "success" | "warning" | "error";
}

const PillSkeleton: React.FC<PillSkeletonProps> = ({
  showIcon = true,
  showLabel = true,
  showTooltip = false,
  variant = "default",
}) => {
  return (
    <div className={`${styles["container"]} ${styles[`container-${variant}`]}`}>
      {showIcon && (
        <Skeleton
          variant="circular"
          width={20}
          height={20}
          className={styles["icon"]}
        />
      )}
      {showLabel && (
        <Skeleton
          variant="text"
          width={40}
          height={20}
          className={styles["label"]}
        />
      )}
      <Skeleton
        variant="text"
        width={60}
        height={20}
        className={styles["value"]}
      />
      {showTooltip && (
        <Tooltip title="">
          <InfoOutlinedIcon className={styles["icon"]} fontSize="small" />
        </Tooltip>
      )}
    </div>
  );
};

export default PillSkeleton;
